import React from "react";
import { POSTS } from "@/data/site";
import { serif, mont, COLORS, es } from "./ui";

const fmt = (d) => (typeof d === "string" ? d : es(d));

const V2Actualidad = () => {
  const [feature, ...rest] = POSTS;
  return (
    <div data-testid="v2-actualidad">
      <section className="max-w-6xl mx-auto px-6 pt-10 pb-12">
        <p className="text-xs uppercase tracking-[0.3em] mb-5" style={{ ...mont, color: COLORS.green, fontWeight: 600 }}>Actualidad</p>
        <h1 className="text-5xl sm:text-6xl font-light leading-[1]" style={serif}>Titulares</h1>
      </section>

      {/* Feature */}
      <section className="max-w-6xl mx-auto px-6 pb-16 grid md:grid-cols-2 gap-10 items-center" style={{ borderTop: `1px solid ${COLORS.border}`, paddingTop: "3rem" }}>
        <div className="overflow-hidden aspect-[16/10]" style={{ border: `1px solid ${COLORS.border}` }}>
          <img src={feature.image} alt={es(feature.title)} className="w-full h-full object-cover" />
        </div>
        <div>
          <p className="text-[11px] uppercase tracking-[0.2em]" style={{ ...mont, color: COLORS.green, fontWeight: 600 }}>{fmt(feature.date)}</p>
          <h2 className="mt-4 text-3xl sm:text-4xl font-normal leading-tight" style={serif}>{es(feature.title)}</h2>
          <p className="mt-4 text-sm" style={{ color: COLORS.mut }}>{feature.tag}</p>
        </div>
      </section>

      {/* Headlines list */}
      <section className="max-w-6xl mx-auto px-6 pb-24">
        {rest.map((p) => (
          <div key={p.slug} className="py-7 flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-8" style={{ borderTop: `1px solid ${COLORS.border}` }}>
            <span className="text-[11px] uppercase tracking-[0.2em] shrink-0 w-44" style={{ ...mont, color: COLORS.green, fontWeight: 600 }}>{fmt(p.date)}</span>
            <div>
              <h3 className="text-xl sm:text-2xl font-normal leading-snug" style={serif}>{es(p.title)}</h3>
              <p className="mt-2 text-xs" style={{ color: COLORS.mut }}>{p.tag}</p>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default V2Actualidad;
